import React, { useState } from "react";
import Container from "../../common/Container";
import Modal from "../../common/Modal";
import Content from "../../common/Content";
import TitleDashboard from "../../common/TitleDashboard";
import TitleBanner from "../../common/TitleBanner";

const Banner = ({
  onOpen = () => {},
  onExit = () => {},
  title = "Test",
  ContentComponent,
  hasModal = true,
  color,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [showModal, setShowModal] = useState(hasModal);

  const open = async (e) => {
    try {
      await onOpen(e);
      setExpanded(!expanded);
    } catch (err) {
      console.log("Error opening", e);
    }
  };

  const exit = async (e) => {
    try {
      await onExit(e);
      setExpanded(false);
      setShowModal(false);
    } catch (err) {
      console.log("error exiting", err);
    }
  };

  const renderStaticBanner = () => {
    return <TitleBanner title={title} color={color} />;
  };

  const renderInteractiveBanner = () => {
    return (
      !showModal && (
        <>
          <TitleDashboard
            title={title}
            onClick={open}
            expanded={expanded}
            color={color}
          />
          {expanded && <Content Component={ContentComponent} exit={exit} />}
        </>
      )
    );
  };

  return (
    <>
      <Container
        paddingHorizontal={0}
        paddingVertical={0}
        heightFull={false}
        className="py-4 mb-4"
      >
        {!ContentComponent ? renderStaticBanner() : renderInteractiveBanner()}
      </Container>
      {!ContentComponent && (
        <Modal
          isOpen={showModal}
          close={() => setShowModal(false)}
          hasCrossContainer={false}
        >
          <div style={{ maxWidth: 500 }}>
            <TitleDashboard
              title={title}
              showArrow={false}
              color={color}
              isModal
            />
            <Content Component={ContentComponent} exit={exit} isModal />
          </div>
        </Modal>
      )}
    </>
  );
};

export default Banner;
